module.exports = __webpack_public_path__ + "static/img/invete_header.f37ce46.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/invete_header.png
// module id = zzA3
// module chunks = 88